import * as React                       from "react";
import ReactTooltip                     from 'react-tooltip';

import "./contact-route.scss";

import {isApiTrue}                     from "@Common/logic/is-api-true";
import {cs}                            from "@Common/react/chain-services";
import {consumeContext}                from "@Common/react/context";
import {Responsive}                    from "@Common/ui-components/responsive";
import {oMapToArr, oMapToArrWithIndex} from "@Common/utils/objects";

import {EmulationModal}      from "../../../common/emulation-modal/emulation-modal";
import {showOfficeEmulation} from "../../../common/logic/show-office-emulation";
import {MultiInputModal}     from "../../common/multi-input-modal/multi-input-modal";
import {ProfileLayout}       from "../common/profile-layout";

export const AccountContactRoute = () => cs(
    ({}, next) => ProfileLayout({activeTab: "contact", next}),
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ["emulationModal", (_, next) => EmulationModal({next})],
    ["agent", ({session}, next) => next(session?.data?.agent)],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["generalData", ({agent}, next) => next(agent && parseAgentData({agent}))],
    ["generalModal", ({apis, session, userLevels}, next) => MultiInputModal({
        next,
        title: "General Information",
        labelLocation: "top",
        onSave: (updateFields) => (apis.next.session.updateAgent({updateFields})),
        reload: () => {
            session?.reload();
            userLevels.reload();
        },
    })],
    ["customizationData", ({agent, company}, next) => next(agent && parseAgentDisplayData({agent, company}))],
    ["customizationModal", ({session, responsive, apis}, next) => MultiInputModal({
        next,
        title: "Customization Information",
        labelLocation: responsive.lt("mobile") ? "top" : "left",
        onSave: (updateFields) => (apis.next.session.updateAgent({updateFields})),
        reload: () => session?.reload(),
    })],
    ({company, agent, userLevels, emulationModal, generalModal, generalData, customizationModal, customizationData}) => (
        !agent ? (
            <div className="contact-route-f9y">
                <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            </div>
        ) : agent?.idAgent && agent?.idAgent != "Branch Order" ? (
            <div className="contact-route-f9y">
                <ReactTooltip  id="contact-route" place="bottom" delayShow={100}/>
                <div className="section">
                    <div className="header">
                        <div className="title">
                            General Information
                        </div>
                        {isApiTrue(company?.prefs.agentEditDisplay) && <a className="edit" xd-qa-type="link" xd-qa-name="Edit General Information" onClick={() => generalModal.show({data: generalData})}>
                            Edit
                        </a>}
                    </div>
                    <div className="card">
                        <div className="name" xd-qa-type="label" xd-qa-name="Agent Name">
                            {agent.agentNameFirst && agent.agentNameFirst + ' '}
                            {agent.agentNameMiddle && agent.agentNameMiddle + ' '}
                            {agent.agentNameLast}
                        </div>
                        <div className="email" xd-qa-type="label" xd-qa-name="Agent Email">
                            {agent.agentEmail}
                        </div>
                        <div className="phone-numbers">
                            <div className="phone">
                                <div className="label">
                                    Phone 1
                                </div>
                                <div className="number" xd-qa-type="label" xd-qa-name="Agent Phone 1" data-for="contact-route" data-tip={agent.agentPhone1}>
                                    {agent.agentPhone1}
                                </div>
                            </div>
                            <div className="phone">
                                <div className="label">
                                    Phone 2
                                </div>
                                <div className="number" xd-qa-type="label" xd-qa-name="Agent Phone 2" data-for="contact-route" data-tip={agent.agentPhone2}>
                                    {agent.agentPhone2}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="header">
                        <div className="title">
                            Customization Information
                        </div>
                        {isApiTrue(company?.prefs.agentEditDisplay) && <a className="edit" xd-qa-type="link" xd-qa-name="Edit Customization Information" onClick={() => customizationModal.show({data: customizationData})}>
                            Edit
                        </a>}
                    </div>
                    <div className="sub-title">
                        You may use this information on product customization
                    </div>
                    <div className="card">
                        {oMapToArrWithIndex(company?.displayFields, (displayField, lineNumber, i) => (
                            <React.Fragment key={i}>
                                <div className="display">
                                    <div className="label" xd-qa-type="label" xd-qa-name={"Agent Display Label " + i} data-for="contact-route" data-tip={displayField}>
                                        {displayField}
                                    </div>
                                    <div className="value" xd-qa-type="label" xd-qa-name={"Agent Display " + i} data-for="contact-route" data-tip={agent["agentDisplay" + lineNumber]}>
                                        {agent["agentDisplay" + lineNumber]}
                                    </div>
                                </div>
                                {(i + 1 < Object.keys(company?.displayFields).length) && <div className="sub-divider"/>}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        ) : (
            <div className="contact-route-f9y">
                <div className="center">
                    {userLevels.userLevel !== 5 ? (<>
                        {"In order to see user details, you must "}
                        <a
                            className="emulation"
                            xd-qa-type="button"
                            xd-qa-name="Emulation"
                            onClick={() => emulationModal.show()}
                        >
                            {showOfficeEmulation(userLevels) ? (
                                "Select Office & User"
                            ) : (
                                "Select User"
                            )}
                        </a>
                    </>) : (
                        "Something went wrong"
                    )}
                </div>
            </div>
        )
    )
);

const parseAgentData = ({agent}) => {
    return [
        {"label": <div>First Name <span style={{color: "red"}}>*</span></div>, "value": agent.agentNameFirst, "mapping": "agentNameFirst", "maxLength": 50},
        {"label": "Middle Name", "value": agent.agentNameMiddle, "mapping": "agentNameMiddle", "maxLength": 50},
        {"label": <div>Last Name <span style={{color: "red"}}>*</span></div>, "value": agent.agentNameLast, "mapping": "agentNameLast", "maxLength": 50},
        {"label": "Phone 1", "value": agent.agentPhone1, "mapping": "agentPhone1", "maxLength": 25},
        {"label": "Phone 2", "value": agent.agentPhone2, "mapping": "agentPhone2", "maxLength": 25},
        {"label": <div>Email <span style={{color: "red"}}>*</span></div>, "value": agent.agentEmail, "mapping": "agentEmail", "maxLength": 60},
    ]
};

const parseAgentDisplayData = ({agent, company}) => {
    return oMapToArr(company?.displayFields, (displayField, lineNumber) => {
        return {"label": displayField, "value": agent["agentDisplay" + lineNumber], "mapping": "agentDisplay" + lineNumber, "maxLength": parseInt(lineNumber) >= 7 ? 80 : 50 }
    });
};
